import { Component } from 'sane-ui'
import { gsap } from 'gsap'

class Logo extends Component {
  constructor ($el, args) {
    super($el, args)

    const $paths = this.$el.find('path')
    const hoverTl = gsap.timeline({ paused: true })

    const ao = { progress: 0 }

    // JUST OPACITY
    hoverTl
      .to($paths, { duration: 0.3, opacity: 0.1, ease: 'none', stagger: 0.06 })
      .to($paths, { duration: 0.3, opacity: 1, ease: 'none', stagger: 0.06 }, 0.35)

    // JUST FILL
    // hoverTl
    //   .to($paths, { duration: 0.3, fill: 'rgb(255, 0, 255)', ease: 'none', stagger: 0.06 })
    //   .to($paths, { duration: 0.3, fill: 'rgb(0, 0, 0)', ease: 'none', stagger: 0.06 }, 0.35)

    // BOTH
    // hoverTl
    //   .to($paths, { duration: 0.3, opacity: 0.1, ease: 'none', stagger: 0.06 })
    //   .to($paths, { duration: 0.3, opacity: 1, fill: 'rgb(255, 0, 255)', ease: 'none', stagger: 0.06 }, 0.35)
    //   .to($paths, { duration: 0.3, fill: 'rgb(0, 0, 0)', ease: 'none', stagger: 0.06 }, 0.7)

    const hoverTween = gsap.to(
      ao, {
        duration: 1.4,
        progress: 1,
        paused: true,
        ease: 'power1.inOut',
        onUpdate: () => { hoverTl.progress(ao.progress) },
      }
    )

    this.$el.mouseenter(() => hoverTween.play(0))
  }
}

export default Logo



// WEBPACK FOOTER //
// ./scripts/components/Logo.js